import IAppLogOpts from '../interfaces/IAppLogOpts';
import { useCallback, useMemo } from 'react';

// Browser console only: the backend /rest/log endpoint was removed because
// client-forged lines polluted the server logs (pentest SLP-I06, ITP-11641).
const useAppLog = () => {
	const error = useCallback((msg: string, opts?: IAppLogOpts) => {
		// eslint-disable-next-line no-console
		console.error('[ERROR]', msg, opts);
	}, []);

	const exception = useCallback((e: unknown, opts?: IAppLogOpts) => {
		// eslint-disable-next-line no-console
		console.error('[EXCEPTION]', e, opts);
	}, []);

	const warning = useCallback((msg: string, opts?: IAppLogOpts) => {
		// eslint-disable-next-line no-console
		console.error('[WARNING]', msg, opts);
	}, []);

	const message = useCallback((msg: string, opts?: IAppLogOpts) => {
		// eslint-disable-next-line no-console
		console.error('[MESSAGE]', msg, opts);
	}, []);

	const object = useCallback((obj: object, opts?: IAppLogOpts) => {
		// eslint-disable-next-line no-console
		console.error('[OBJECT]', obj, opts);
	}, []);

	return useMemo(
		() => ({
			error,
			exception,
			warning,
			message,
			object,
		}),
		[error, exception, message, object, warning],
	);
};

export default useAppLog;
